import { ChangeDetectionStrategy, Component, OnInit, Inject, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { FileUploadService } from '../../fileUpload/file-upload/file-upload.service';
import { ImportDiaologTableService } from './import-dialog-table.service';
// TODO Rename and put in its own module

@Component({
  selector: 'dl-import-dialog-table',
  templateUrl: './import-dialog-table.component.html',
  styleUrls: ['./import-dialog-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImportDialogTableComponent implements OnInit {
  public importButton = true;

  // drop down
  public frmctrlcustomerID = new FormControl();
  public frmctrlcustomerName = new FormControl();
  public frmctrlcustomerContactName = new FormControl();
  public frmctrlcustomerContactEmail = new FormControl();

  public options: string[] = [];
  public formDisabled = false;
  public constructor(private fileuploadService: FileUploadService, private importdialogTable: ImportDiaologTableService) {}

  public filteredOptionscustomerID: Observable<string[]>;
  public filteredOptionscustomerName: Observable<string[]>;
  public filteredOptionscustomerContactName: Observable<string[]>;
  public filteredOptionscustomerContactEmail: Observable<string[]>;
  public getFileData: Observable<any>;

  public ngOnInit(): void {
    this.getFileData = this.onFileUploadData();
  }

  public onkeyDownEvent(evt: KeyboardEvent): void {
    evt.preventDefault();
  }
  public onFileUploadData(): Observable<string[]> {
    this.fileuploadService.fileuploadDataobservable$.subscribe(f => {
      this.options = f.columnDetails;

      // drop down
      this.filteredOptionscustomerID = this.resetFilter(this.frmctrlcustomerID);
      this.filteredOptionscustomerName = this.resetFilter(this.frmctrlcustomerName);
      this.filteredOptionscustomerContactName = this.resetFilter(this.frmctrlcustomerContactName);
      this.filteredOptionscustomerContactEmail = this.resetFilter(this.frmctrlcustomerContactEmail);
      if (f.action === 'delete') {
        this.frmctrlcustomerID.setValue('');
        this.frmctrlcustomerName.setValue('');
        this.frmctrlcustomerContactName.setValue('');
        this.frmctrlcustomerContactEmail.setValue('');
        this.fileuploadService.sendIfValidData('Not Import button Active');
      }else{
        this.frmctrlcustomerID.setValue(this.options.find(str=> str.match(/\b(Account ID)\b/i)) || '');
        this.frmctrlcustomerName.setValue(this.options.find(str=> str.match(/\b(Account name)\b/i)) || '');
        this.frmctrlcustomerContactName.setValue(this.options.find(str=> str.match(/\b(Account contact name)\b/i)) || '');
        this.frmctrlcustomerContactEmail.setValue(this.options.find(str=> str.match(/\b(Account contact email)\b/i)) || '');
        this.updateImportbtn();
      }
    });
    return;
  }

  private resetFilter(formControlEditableDropdown: FormControl): Observable<string[]> {
    return formControlEditableDropdown.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value ? value.toLowerCase() : '';
    const result = this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
    const checkResult = result && result[0] === value && result.length === 1 ? this.options : this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);

    this.updateImportbtn();
    return checkResult;
  }

  public updateImportbtn(frmctrl?: any): void {
    const columnlist = {
      Customer_ID: '',
      Customer_name: '',
      Customer_contact_name: '',
      Customer_contact_email: ''
    };
    if (this.frmctrlcustomerID.value !== null && this.frmctrlcustomerName.value !== null && this.frmctrlcustomerContactName.value !== null && this.frmctrlcustomerContactEmail.value !== null) {
      if (this.options.filter(option => this.frmctrlcustomerID.value.toLowerCase() === option.toLowerCase()).length !== 0 && this.options.filter(option => this.frmctrlcustomerName.value.toLowerCase() === option.toLowerCase()).length !== 0 && this.options.filter(option => this.frmctrlcustomerContactName.value.toLowerCase() === option.toLowerCase()).length !== 0 && this.options.filter(option => this.frmctrlcustomerContactEmail.value.toLowerCase() === option.toLowerCase()).length !== 0) {
        columnlist.Customer_ID = this.frmctrlcustomerID.value;
        columnlist.Customer_name = this.frmctrlcustomerName.value;
        columnlist.Customer_contact_name = this.frmctrlcustomerContactName.value;
        columnlist.Customer_contact_email = this.frmctrlcustomerContactEmail.value;
        this.fileuploadService.sendIfValidData('Import button Active');
        this.importdialogTable.getMappedfileData(columnlist);
      } else {
        this.fileuploadService.sendIfValidData('Not Import button Active');
      }
    }
  }
}
